// Loader.tsx
"use client";
import React, { useEffect, useState } from 'react';

const messages = [
  "Fetching some magic...",
  "Hang tight, it's on the way!",
  "Polishing the pixels...",
  "Getting things ready...",
  "Brewing your request...",
  "Almost there...",
  "Loading the awesomeness...",
];

const Loader: React.FC = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const randomMessage = messages[Math.floor(Math.random() * messages.length)];
    setMessage(randomMessage);
  }, []);

  return (
    <div className="xloader-container">
            <div className="xloader-bar"></div>
        </div>
  );
};

export default Loader;
